// extracted by mini-css-extract-plugin
export default {"container":"Features_container__IOCIh","subHeading":"Features_subHeading__slUi+","item":"Features_item__qBC4w","title":"Features_title__Wo39O","icon":"Features_icon__LwCkK"};